"use client";

import type { ReportMeasure, ReportQueryResult } from "@gettactic/api";
import React from "react";
import { factsAsOfLabel } from "../lib/factsAsOf";

interface LineageRowProps {
  label: string;
  value: string;
}

const LineageRow: React.FC<LineageRowProps> = ({ label, value }) => (
  <div className="flex justify-between gap-2.5 text-[11.5px]">
    <span className="shrink-0 text-neutral-400">{label}</span>
    <span className="text-right text-neutral-700">{value}</span>
  </div>
);

interface LineageCardProps {
  measure: ReportMeasure;
  result?: ReportQueryResult;
}

/** "Behind the number": what a measure counts, where from, what it leaves out. */
export const LineageCard: React.FC<LineageCardProps> = ({
  measure,
  result
}) => (
  <div className="flex flex-col gap-2">
    <p className="text-[12px] text-neutral-600 leading-[17px]">
      {measure.description}
    </p>
    <LineageRow label="Source" value={measure.lineage.source} />
    <LineageRow label="Counting" value={measure.lineage.counting} />
    <LineageRow label="Excludes" value={measure.lineage.excludes} />
    {result ? (
      <LineageRow
        label="Window"
        value={`${result.meta.from} – ${result.meta.to}, by ${result.meta.grain}${result.meta.office_scoped ? ", your offices" : ""}`}
      />
    ) : null}
    {result?.meta.facts_as_of ? (
      <LineageRow
        label="Freshness"
        value={factsAsOfLabel(result.meta.facts_as_of) ?? ""}
      />
    ) : null}
  </div>
);
